var MakeAppointmentCurrentPage = {
    SESSION_NAME: 'appointment_flow',
    VISITED_SESSION_NAME: 'appointment_visited',
    APPT_FLOW_URLS: {
        "servicesInfo": "/appointment/services-info",
        "dateTime": "/appointment/date-time"
    },
    appointmentFlow: null,
    appointmentVisited: null,
    currentPage: null,

    /**
     * Handles appointment session resets
     */
    resetApptSessions: function(){
        MakeAppointmentCurrentPage.appointmentFlow = {
            "servicesInfo": false,
            "dateTime": false
        }
        MakeAppointmentCurrentPage.appointmentVisited = {
            "servicesInfo": true,
            "dateTime": false
        }
        MakeAppointmentCurrentPage.updateAppointmentVisitedSession();
        MakeAppointmentCurrentPage.updateAppointmentFlowSession();
        MakeAppointmentServicesInfo.resetSession();
        MakeAppointmentDate.resetSession();
        MakeAppointmentCurrentPage.handleCurrentPageLinks();
        MakeAppointmentCurrentPage.displayFlow();
    },

    init: function(){

        // Initialize appointment_visited session if not created
        if(!sessionStorage.getItem(MakeAppointmentCurrentPage.VISITED_SESSION_NAME)){
            MakeAppointmentCurrentPage.appointmentVisited = {
                "servicesInfo": true,
                "dateTime": false
            };
            MakeAppointmentCurrentPage.updateAppointmentVisitedSession();
        }

        // Initialize appointment_flow session if not created yet
        if(!sessionStorage.getItem(MakeAppointmentCurrentPage.SESSION_NAME)){
            if(Util.getCookie('store_location') != null){
                MakeAppointmentCurrentPage.appointmentFlow = {
                    "servicesInfo": false,
                    "dateTime": false
                };
                MakeAppointmentCurrentPage.updateAppointmentFlowSession();
                MakeAppointmentCurrentPage.handleAppointmentFlow("servicesInfo");
            }
            // Handles if there is no location set...
            else{
                MakeAppointmentCurrentPage.handleCurrentPageLinks();
                MakeAppointmentCurrentPage.displayFlow();
            }
        }
        else if(Util.getCookie('store_location') === null){
            sessionStorage.removeItem(MakeAppointmentCurrentPage.SESSION_NAME);
        }
        else{
            MakeAppointmentCurrentPage.handleAppointmentFlow("servicesInfo");
        }
    },

    /**
     * Allows next page in flow to be viewed if form is validated/user confirms information.
     * Datetime is handled on form submission (make-appointment-date.js)
     * Info will also need to be handled in form submission
     */
    nextPageClickHandler: function(){
        jQuery('.make-appointment-next-btn').on('click', function(event){
            MakeAppointmentCurrentPage.appointmentFlow[MakeAppointmentCurrentPage.currentPage] = true;
            MakeAppointmentCurrentPage.updateAppointmentFlowSession();
        });
    },

    /**
     * Handles the appointment flow. Will redirect back to appropiate page if user attempts to skip a step.
     * Updates visited session info
     */
    handleAppointmentFlow: function(page){
        if(page != "servicesInfo" && !Util.getCookie("store_location")) {
            sessionStorage.removeItem(MakeAppointmentCurrentPage.SESSION_NAME);
            sessionStorage.removeItem(MakeAppointmentCurrentPage.VISITED_SESSION_NAME);

            MakeAppointmentCurrentPage.redirectFlow('servicesInfo');
        }

        MakeAppointmentCurrentPage.currentPage = page;
        var hasSession = sessionStorage.getItem(MakeAppointmentCurrentPage.SESSION_NAME) != null && 
            sessionStorage.getItem(MakeAppointmentCurrentPage.VISITED_SESSION_NAME) != null;
        if(hasSession){
            MakeAppointmentCurrentPage.appointmentFlow = JSON.parse(sessionStorage.getItem(MakeAppointmentCurrentPage.SESSION_NAME));
            MakeAppointmentCurrentPage.appointmentVisited = JSON.parse(sessionStorage.getItem(MakeAppointmentCurrentPage.VISITED_SESSION_NAME));
            switch(page){
                case "servicesInfo":
                    MakeAppointmentCurrentPage.handleCurrentPageLinks();
                    MakeAppointmentCurrentPage.displayFlow();
                    MakeAppointmentCurrentPage.nextPageClickHandler();
                    break;
                case "dateTime":
                    MakeAppointmentCurrentPage.handleDateTime();
                    MakeAppointmentCurrentPage.handleCurrentPageLinks();
                    MakeAppointmentCurrentPage.nextPageClickHandler();
                    break;
                case "summary":
                    MakeAppointmentCurrentPage.handleSummary();
                default:
                    break;
            }
        }
        else{
            if (page != "servicesInfo")
                MakeAppointmentCurrentPage.redirectFlow('servicesInfo');
        }
    },

    /**
     * Handles redirects for the services page
     */
    handleDateTime: function(){
        if(MakeAppointmentCurrentPage.appointmentFlow.servicesInfo == false)
            MakeAppointmentCurrentPage.redirectFlow('servicesInfo');
        else{
            MakeAppointmentCurrentPage.appointmentVisited.dateTime = true;
            MakeAppointmentCurrentPage.updateAppointmentVisitedSession();
            MakeAppointmentCurrentPage.displayFlow();
        }
    },
    /**
     * Handles redirects for the summary page
     */
    handleSummary: function(){
        if(MakeAppointmentCurrentPage.appointmentFlow.servicesInfo == false)
            MakeAppointmentCurrentPage.redirectFlow('servicesInfo');
        else if(MakeAppointmentCurrentPage.appointmentFlow.dateTime == false)
            MakeAppointmentCurrentPage.redirectFlow('dateTime');
        else{
            MakeAppointmentCurrentPage.displayFlow();
            MakeAppointmentSummaryPage.removeSessionStorages();
        }
    },
    /**
     * Activates current and visited links
     * Deactivates future links
     * In the top current page section
     */
    handleCurrentPageLinks: function(){
        var i = 0;
        jQuery.each(MakeAppointmentCurrentPage.appointmentVisited, function(key, value){
            var desktop = jQuery('.make-appointment-current-pages').children().eq(i);
            var mobile = jQuery('.mobile-current-page-numbers').children().eq(i);
            if (window.location.pathname === "/appointment/services-info/") {
                jQuery(jQuery('.make-appointment-current-pages').children().eq(0)).find('a').addClass('active');
                jQuery(jQuery('.mobile-current-page-numbers').children().eq(0)).find('a').addClass('active');
            } else if(window.location.pathname === "/appointment/date-time/") {
                jQuery(jQuery('.make-appointment-current-pages').children().eq(1)).find('a').addClass('active');
                jQuery(jQuery('.mobile-current-page-numbers').children().eq(1)).find('a').addClass('active');
            } else {
                jQuery(desktop).find('a').removeAttr('href');
                jQuery(mobile).find('a').removeAttr('href');
            }
            i++;
        });
    },
    /**
     * Displays the appointment information if current page is valid/not being redirected
     */
    displayFlow: function(){
        jQuery('.make-appointment-content').fadeIn();
    },
    /**
     * Updates the appointment flow session data
     * If current page is true, user is alble to move to next page in flow
     */
    updateAppointmentFlowSession: function(){
        sessionStorage.setItem(MakeAppointmentCurrentPage.SESSION_NAME, JSON.stringify(MakeAppointmentCurrentPage.appointmentFlow));
    },
    /**
     * Updates the appointment visited pages session data
     */
    updateAppointmentVisitedSession: function(){
        sessionStorage.setItem(MakeAppointmentCurrentPage.VISITED_SESSION_NAME, JSON.stringify(MakeAppointmentCurrentPage.appointmentVisited));
    },
    /**
     * Handles flow redirect
     */
    redirectFlow: function(flow){
        var url = MakeAppointmentCurrentPage.APPT_FLOW_URLS[flow];
        window.location = window.location.origin + url;
    }
}